import { render, staticRenderFns } from "./TaskListItemDuration.vue?vue&type=template&id=8aefb890&"
import script from "./TaskListItemDuration.vue?vue&type=script&lang=js&"
export * from "./TaskListItemDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports